import { render } from "./HomeHowToBuy.vue?vue&type=template&id=dc8dbcf4&scoped=true"
import script from "./HomeHowToBuy.vue?vue&type=script&lang=js"
export * from "./HomeHowToBuy.vue?vue&type=script&lang=js"

import "./HomeHowToBuy.vue?vue&type=style&index=0&id=dc8dbcf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc8dbcf4"]])

export default __exports__